exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".same-row-spaced-apart-aligned[data-v-6a9b21cb]{display:flex;justify-content:space-between;align-items:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-6a9b21cb&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/App/protected/components/customer/CustomerCreate.vue
// module id = 594
// module chunks = 0